import { string } from "yup";

import { phoneNumber } from "@/utilities/validators";

import { ContactInformation, PhoneType } from "./types";

export function rules(form: ContactInformation) {
  const phoneValidator =
    (phoneNumber: string | null) => (phoneType: PhoneType | null) =>
      phoneNumber
        ? !!phoneType || "You must specify what type of number this is"
        : true;

  const contactName = () =>
    string().matches(/\w+(\s+\w+)+/, {
      message: "provide first and last name",
      excludeEmptyString: true,
    });

  const contact2Required =
    form.contact2.contactName ||
    form.contact2.contactRelation ||
    form.contact2.address1 ||
    form.contact2.address2 ||
    form.contact2.city ||
    form.contact2.state ||
    form.contact2.country ||
    form.contact2.postal ||
    form.contact2.phone1 ||
    form.contact2.phone1Type ||
    form.contact2.phone2 ||
    form.contact2.phone2Type ||
    form.contact2.phone3 ||
    form.contact2.phone3Type;

  return {
    contact1: {
      contactName: contactName().nullable().required("required"),
      contactRelation: string().nullable().required("required"),
      address1: string().nullable().required("required"),
      address2: string().nullable(),
      city: string().nullable().required("required"),
      state: string().nullable().required("required"),
      postal: string().nullable().required("required"),
      country: string().nullable().required("required"),
      phone1: {
        phone: phoneNumber().required("required"),
        phoneType: [phoneValidator(form.contact1.phone1)],
      },
      phone2: {
        phone: phoneNumber(),
        phoneType: [phoneValidator(form.contact1.phone2)],
      },
      phone3: {
        phone: phoneNumber(),
        phoneType: [phoneValidator(form.contact1.phone3)],
      },
    },
    contact2: {
      contactName: contact2Required
        ? contactName().nullable().required("required")
        : contactName().nullable(),
      contactRelation: contact2Required
        ? string().nullable().required("required")
        : string().nullable(),
      address1: contact2Required
        ? string().nullable().required("required")
        : string().nullable(),
      address2: string().nullable(),
      city: contact2Required
        ? string().nullable().required("required")
        : string().nullable(),
      state: contact2Required
        ? string().nullable().required("required")
        : string().nullable(),
      country: contact2Required
        ? string().nullable().required("required")
        : string().nullable(),
      postal: contact2Required
        ? string().nullable().required("required")
        : string().nullable(),
      phone1: {
        phone: contact2Required
          ? phoneNumber().required("required")
          : phoneNumber(),
        phoneType: [phoneValidator(form.contact2.phone1)],
      },
      phone2: {
        phone: phoneNumber(),
        phoneType: [phoneValidator(form.contact2.phone2)],
      },
      phone3: {
        phone: phoneNumber(),
        phoneType: [phoneValidator(form.contact2.phone3)],
      },
    },
  };
}
